import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 2fr 4fr 4fr 4fr 1fr',
    gridGap: 20,
    alignItems: 'center',
    padding: '12px 4px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: (props: { index: number }) =>
      props.index % 2 !== 0
        ? theme.palette.grey[200]
        : theme.palette.background.default
  },
  rootFa: {
    gridTemplateColumns: '2fr 0.5fr 2fr 4fr 4fr 4fr 1fr'
  },
  tableHeader: { textAlign: 'left' }
}))

export default useStyles
